// Copyright (c) 2017 Deere & Company

import {
    onCreateClaim,
    updateCreateClaimModalVisibility
} from './create-claim-modal-visibility';
import {
    openAccordion,
    readAllClaims,
    toggleAccordion,
    updateListFilterBy,
    updateListSortBy,
    updateListSortDirection
} from './all-claims';
import {
    resetAllFacets,
    selectAllClaimStatusOnInitialLoad,
    selectAllDealersOnInitialLoad,
    selectDateOnInitialLoad,
    toggleClaimStatusFacetItems,
    toggleDealerAccountFacetItems,
    updateClaimStatusFacetItem,
    updateDateRangeFacet,
    updateDateType,
    updateDealerAccountFacetInput,
    updateDealerAccountFacetItem
} from './facets';
import {exportToExcel} from './export-to-excel';
import exportToExcelActions from '../../../shared/action-creators/excel-layout-modal-actions-combined';
import {handleSearchAction} from '../../claim-search/action-creators/handle-search-action';
import {onSearch} from '../../shared/action-creators/search';
import {readClaimTypes} from './get-claim-types';
import {readDealerInvoices} from '../../dealer-invoices/action-creators/read-dealer-invoices';
import {toggleReportsAccordion} from '../../shared/action-creators/reports-accordion';
import {updateSearchByDropDown} from '../../shared/action-creators/search-by-dropdown';
import {updateSearchQueryString} from '../../shared/action-creators/search-query-string';

export default {
    ...exportToExcelActions,
    exportToExcel,
    handleSearchAction,
    onCreateClaim,
    onSearch,
    openAccordion,
    readAllClaims,
    readClaimTypes,
    readDealerInvoices,
    resetAllFacets,
    selectAllClaimStatusOnInitialLoad,
    selectAllDealersOnInitialLoad,
    selectDateOnInitialLoad,
    toggleAccordion,
    toggleClaimStatusFacetItems,
    toggleDealerAccountFacetItems,
    toggleReportsAccordion,
    updateClaimStatusFacetItem,
    updateCreateClaimModalVisibility,
    updateDateRangeFacet,
    updateDateType,
    updateDealerAccountFacetInput,
    updateDealerAccountFacetItem,
    updateListFilterBy,
    updateListSortBy,
    updateListSortDirection,
    updateSearchByDropDown,
    updateSearchQueryString
};



// WEBPACK FOOTER //
// ./src/claim/all-claims/action-creators/index.js